// Ant Design theme configuration
export const theme = {
  token: {
    colorPrimary: '#E39112',
    colorSuccess: '#10b981',
    colorWarning: '#E39112',
    colorError: '#ef4444',
    colorInfo: '#C37D0F',
    borderRadius: 10,
    fontFamily: 'Geist, Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
  },
  components: {
    Layout: {
      headerBg: '#ffffff',
      siderBg: '#0b1220',
      triggerBg: '#111827',
      triggerColor: '#ffffff',
    },
    Menu: {
      darkItemBg: '#0b1220',
      darkItemHoverBg: '#111827',
      darkItemSelectedBg: '#E39112',
      darkItemSelectedColor: '#ffffff',
    },
    Button: {
      primaryColor: '#ffffff',
      primaryBg: '#E39112',
      borderRadius: 10,
    },
    Card: {
      borderRadius: 14,
      boxShadow: '0 10px 25px rgba(2, 6, 23, 0.06), 0 2px 6px rgba(2, 6, 23, 0.04)',
    },
  },
};
